<template>
  <BootstrapTable
    :columns="columns"
    :data-url="data"
    :options="options"
    data-side-pagination="server"
    data-pagination="true"
  />
</template>

<script>
import BootstrapTable from 'bootstrap-table/dist/bootstrap-table-vue.esm.js'

export default {
  components: {
    BootstrapTable
  },
  data () {
    return {
      columns: [
        {
          field: 'name',
          title: 'Deck Name',
          sortable: true,
        },
        {
          field: 'sent_at',
          title: 'Sent At',
          sortable: true,
          formatter: function(value, row, index){
            
            if(value !== null){

              value = new Date( value.replace(/-/g, "/") + ' UTC');

              value = value.getDate() + '/' + (value.getMonth()+1) + '/' + value.getFullYear() + ' ' + value.getHours() + ':' + (value.getMinutes()<10?'0':'') + value.getMinutes();
            }

            return value;
          }
        },
        {
          field: 'send_type',
          title: 'Send Type',
          sortable: true,
          formatter: function(value, row, index){
            switch(value){
              case 'bulk':
                value = 'Mailing List Send';
              break;
              case 'single':
                value = 'Single Recipient';
              break;
              case 'share':
                value = 'Shared Link';
              break;
            }
            return value;
          }
        },
        {
          field: 'send_via',
          title: 'Sent By',
          sortable: true,
          formatter: function(value, row, index){
            switch(value){
              case 'email':
                value = 'Email';
              break;
              case 'sms':
                value = 'SMS';
              break;
              case 'both':
                value = 'Email & SMS';
              break;
              case null:
                value = 'Link';
              break;
            }
            return value;
          }
        },
        {
          field: 'view_count',
          title: 'View Count',
          sortable: true,
        },
        {
          field: 'tools',
          title: 'Tools',
          formatter: function(value, row, index){

            send_type: "single"

            var $return = [
                ' <a class="table-control btn btn-outline-purple btn-sm" href="/deck/duplicate/'+row.id+'" title="Duplicate">',
                '<i class="fa fa-copy"></i>',
                '</a>',
                ' <a class="table-control btn btn-outline-orange btn-sm" href="/deck/results/'+row.id+'" title="Results">',
                '<i class="fa fa-line-chart"></i>',
                '</a>',
                ' <a class="table-control btn btn-outline-pink btn-sm" href="/deck/preview/'+row.id+'" target="_blank" title="Preview">',
                '<i class="fa fa-search"></i>',
                '</a>',
                ' <a class="table-control btn btn-outline-cyan btn-sm" href="/deck/delete/'+row.id+'" target="_blank" title="Delete">',
                '<i class="fa fa-trash"></i>',
                '</a>'
              ].join('');

              return $return;

          },
          width: 160,
          align: 'center'
        }
      ],
      data: '/deck/sent/list',
      options: {
        search: true,
      }
    }
  }
}




</script>